module.exports = __webpack_public_path__ + "static/media/error-light.0a0bbe01.svg";